import { render } from "./massive-tickets-list.vue?vue&type=template&id=9bdd371c&scoped=true"
import script from "./massive-tickets-list.vue?vue&type=script&lang=js"
export * from "./massive-tickets-list.vue?vue&type=script&lang=js"

import "./massive-tickets-list.vue?vue&type=style&index=0&id=9bdd371c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bdd371c"]])

export default __exports__